import { Agent } from "./Agent"
import { Avatar } from "./Avatar"
import { AvatarScreen, VideoScreen } from "./Screen"
import { Video } from "./Video"

export enum SnackbarType {
  success = "success",
  error = "error",
}

export interface SnackbarProps {
  text: string
  open: boolean
  severity?: SnackbarType
}

export const initialSnackbarProps: SnackbarProps = {
  open: false,
  severity: SnackbarType.error,
  text: "",
}

export enum Colors {
  grey100 = "#F7F8FA",
  black = "#000000",
  white = "#FFFFFF",
  grey200 = "#F0EEF5",
  sideBarDark = "#4E405A",
  sideBarDarkOpacity = "#4E405A50",
  purple900 = "#4019B6",
  purple800 = "#4A1FB8",
  purple500 = "#6633CC",
  purple200 = "#ECE6FF",
  purple100 = "#F5F2FF",
  grey300 = "#E7E6ED",
  almostBlack = "#220738",
  grey500 = "#A69FAC",
  grey800 = "#848484",
  grey900 = "#666666",
  red400 = "#F04438",
  red500 = "#F00000",
}

export interface ImageListItemProps
  extends Partial<Avatar>, Partial<Video>, Partial<Omit<Agent, "language">> {
  selected: boolean
}

export enum ScreenModes {
  video = "video",
  avatar = "avatar",
}

export const getScreenModeFromScreen = (
  screen: VideoScreen | AvatarScreen,
): ScreenModes => {
  if (Object.keys(AvatarScreen).includes(screen)) {
    return ScreenModes.avatar
  }
  if (Object.keys(VideoScreen).includes(screen)) {
    return ScreenModes.video
  }
}

export const getScreenModeFromMatchedElement = (
  matchedElement: Video | Avatar,
): ScreenModes => {
  if (isTypeofVideo(matchedElement)) {
    return ScreenModes.video
  }
  return ScreenModes.avatar
}

export enum SidebarTextValues {
  avatars = "Avatars",
  textToVideo = "Text-to-video",
  myAgents = "My Agents",
  knowledgeBase = "Knowledge base",
  conversations = "Conversations",
  analytics = "Analytics",
  helpUsImprove = "Help us improve",
  settings = "Settings",
  apiKeys = "API Keys",
  faq = "FAQs",
  home = "Home",
}

export const isTypeofVideo = (e: Video | Avatar | Agent): e is Video => {
  return (e as Video)?.script != null
}

export const isTypeofAgent = (e: Agent | Avatar): e is Agent => {
  return (e as Agent)?.name != null
}

export const EntityTypes = {
  video: "video",
  avatar: "avatar",
  agent: "agent",
}
